// src/components/Contact.jsx
import React, { useState } from "react";
import {
  FaMapMarkerAlt,
  FaPhone,
  FaEnvelope,
  FaClock,
  FaInstagram,
  FaFacebook,
  FaWhatsapp,
} from "react-icons/fa";

const services = [
  "Individual Counseling",
  "Family Counseling",
  "Couple / Relationship Counseling",
  "Marriage & Pre-Marital Counseling",
  "Children & Adolescent Counseling",
  "Parenting Guidance Counseling",
  "Stress Management Counseling",
  "Anxiety & Depression Counseling",
  "Anger Management Counseling",
  "Personality Development Counseling",
  "Emotional & Behavioral Counseling",
  "Study Management & Student Counseling",
  "Career Guidance Counseling",
  "Learning Disability Counseling",
  "Addiction / Substance Abuse Counseling",
  "Mental Health Awareness & Wellness Support",
  "Group Counseling Sessions",
  "Confidence & Self-Esteem Building",
  "Psychological Guidance for Life Challenges",
  "Mind Relaxation & Emotional Well-being Sessions",
];

const initialForm = {
  name: "",
  email: "",
  phone: "",
  service: "",
  message: "",
};

const Contact = () => {
  const [form, setForm] = useState(initialForm);
  const [errors, setErrors] = useState({});

  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

const validate = () => {
  const e = {};

  // Name
  if (!form.name.trim()) {
    e.name = 'Full name is required.';
  } else if (form.name.trim().length < 3) {
    e.name = 'Name must be at least 3 characters.';
  } else if (!/^[a-zA-Z\s]+$/.test(form.name.trim())) {
    e.name = 'Name can only contain letters and spaces.';
  }

  // Email
  if (!form.email.trim()) {
    e.email = 'Email is required.';
  } else if (
    !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email.trim())
  ) {
    e.email = 'Please enter a valid email address.';
  }

  // Phone
  if (!form.phone.trim()) {
    e.phone = 'Phone number is required.';
  } else if (!/^[6-9]\d{9}$/.test(form.phone.trim())) {
    e.phone = 'Please enter a valid 10-digit Indian mobile number.';
  }

  // Service
  if (!form.service) {
    e.service = 'Please select a service.';
  }

  return e;
};

const handleChange = (e) => {
  const { name, value } = e.target;

  if (name === 'phone') {
  const cleaned = value.replace(/\D/g, '').slice(0, 10);

  setForm((prev) => ({
    ...prev,
    [name]: cleaned,
  }));

  return;
}

  setForm((prev) => ({
    ...prev,
    [name]: value,
  }));

  setErrors((prev) => ({
    ...prev,
    [name]: '',
  }));
};

const validateField = (name, value) => {
  let error = '';

  switch (name) {
    case 'name':
      if (!value.trim()) {
        error = 'Full name is required.';
      } else if (value.trim().length < 3) {
        error = 'Name must be at least 3 characters.';
      } else if (!/^[a-zA-Z\s]+$/.test(value.trim())) {
        error = 'Name can only contain letters and spaces.';
      }
      break;

    case 'email':
      if (!value.trim()) {
        error = 'Email is required.';
      } else if (
        !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.trim())
      ) {
        error = 'Please enter a valid email address.';
      }
      break;

    case 'phone':
      if (!value.trim()) {
        error = 'Phone number is required.';
      } else if (!/^[6-9]\d{9}$/.test(value.trim())) {
        error = 'Please enter a valid 10-digit mobile number.';
      }
      break;

    case 'service':
      if (!value) {
        error = 'Please select a service.';
      }
      break;

    default:
      break;
  }

  setErrors((prev) => ({
    ...prev,
    [name]: error,
  }));
};

  const handleSubmit = async (e) => {
    e.preventDefault();

    const errs = validate();

    if (Object.keys(errs).length > 0) {
      setErrors(errs);
      return;
    }

    setLoading(true);

    try {
      const payload = {
        full_name: form.name,
        email: form.email,
        mob: Number(form.phone),
        interested_service: form.service,
        message: form.message,
      };

      const response = await fetch(
        "https://vihamindcare.com/visitNow/sendVisitMail",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        },
      );

      const result = await response.text();

      if (response.ok && result === "SENDMAIL") {
        setSubmitted(true);
        setForm(initialForm);
        setErrors({});
      } else {
        alert("Unable to send message. Please try again.");
      }
    } catch (error) {
      console.error("Mail API Error:", error);
      alert("Server error. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section id="contact" className="viha-section" style={styles.section}>
      <div style={styles.container}>
        <div style={styles.header}>
          <span className="section-badge">Get in Touch</span>
          <h2 style={styles.title}>We're Here for You</h2>
        </div>

        <div style={styles.twoCol}>
          {/* Left: Contact info */}
          <div style={styles.infoCol} data-aos="fade-right" data-aos-delay="0">
            <div style={styles.infoCard}>
              {[
                {
                  icon: <FaMapMarkerAlt />,
                  label: "Address",
                  value:
                    "VIHA MindCare Psychology Centre, Shop No.9, Plot No.42/43, Ground Floor, Surya Darshan Residency, Sector-20, Kamothe, Panvel, Navi Mumbai - 410209",
                },
                // { icon: <FaPhone />, label: "Phone", value: "+91 9420085453" },
                { icon: <FaPhone />, label: "Phone", value: "+91 9004910709" },

                {
                  icon: <FaEnvelope />,
                  label: "Email",
                  value: "vihamindcare@gmail.com",
                },
                {
                  icon: <FaClock />,
                  label: "Hours",
                  value: "Mon – Sat, 9 AM – 7 PM",
                },
              ].map((item) => (
                <div key={item.label} style={styles.infoRow}>
                  <div style={styles.infoIcon}>{item.icon}</div>
                  <div>
                    <div style={styles.infoLabel}>{item.label}</div>
                    <div style={styles.infoValue}>{item.value}</div>
                  </div>
                </div>
              ))}

              <div style={styles.socialRow}>
                {[
                  {
                    icon: <FaInstagram />,
                    href: "#",
                    color: "#E1306C",
                    label: "Instagram",
                  },
                  {
                    icon: <FaFacebook />,
                    href: "#",
                    color: "#1877F2",
                    label: "Facebook",
                  },
                  {
                    icon: <FaWhatsapp />,
                    // href: "https://wa.me/9420085453",
                    href: "https://wa.me/9004910709",
                    color: "#25D366",
                    label: "WhatsApp",
                  },
                ].map((s) => (
                  <a
                    key={s.label}
                    href={s.href}
                    target="_blank"
                    rel="noreferrer"
                    aria-label={s.label}
                    style={styles.socialIcon(s.color)}
                  >
                    {s.icon}
                  </a>
                ))}
              </div>
            </div>
          </div>

          {/* Right: Contact form */}
          <div style={styles.formCol} data-aos="fade-left" data-aos-delay="150">
            {submitted ? (
              <div style={styles.successBox}>
                <div style={{ fontSize: 52, marginBottom: 16 }}>✅</div>
                <h3 style={{ color: "#1B3F6E", marginBottom: 10 }}>
                  Message Sent!
                </h3>
                <p style={{ color: "#6C757D" }}>
                  Thank you for reaching out. Our team will contact you within
                  24 hours.
                </p>
                <button
                  style={styles.resetBtn}
                  onClick={() => setSubmitted(false)}
                >
                  Send Another Message
                </button>
              </div>
            ) : (
              <form onSubmit={handleSubmit} noValidate style={styles.form}>
                {/* Full Name */}
                <div style={styles.fieldWrap}>
                  <label style={styles.label} htmlFor="name">
                    Full Name *
                  </label>
                  <input
                    id="name"
                    name="name"
                    type="text"
                    value={form.name}
                    onChange={handleChange}
                    onBlur={() => validateField('name', form.name)}
                    placeholder="Your full name"
                    style={styles.input(!!errors.name)}
                    aria-required="true"
                    aria-describedby="name-error"
                  />
                  {errors.name && (
                    <span id="name-error" style={styles.error}>
                      {errors.name}
                    </span>
                  )}
                </div>

                {/* Email */}
                <div style={styles.fieldWrap}>
                  <label style={styles.label} htmlFor="email">
                    Email Address *
                  </label>
                  <input
                    id="email"
                    name="email"
                    type="email"
                    value={form.email}
                    onChange={handleChange}
                    onBlur={() => validateField('email', form.email)}
                    placeholder="you@example.com"
                    style={styles.input(!!errors.email)}
                    aria-required="true"
                    aria-describedby="email-error"
                  />
                  {errors.email && (
                    <span id="email-error" style={styles.error}>
                      {errors.email}
                    </span>
                  )}
                </div>

                {/* Phone */}
                <div style={styles.fieldWrap}>
                  <label style={styles.label} htmlFor="phone">
                    Phone Number *
                  </label>
                  <input
                    id="phone"
                    name="phone"
                    type="tel"
                    maxLength={10}
                    value={form.phone}
                    onChange={handleChange}
                    onBlur={() => validateField('phone', form.phone)}
                    placeholder="10-digit mobile number"
                    style={styles.input(!!errors.phone)}
                    aria-required="true"
                    aria-describedby="phone-error"
                  />
                  {errors.phone && (
                    <span id="phone-error" style={styles.error}>
                      {errors.phone}
                    </span>
                  )}
                </div>

                {/* Service dropdown */}
                <div style={styles.fieldWrap}>
                  <label style={styles.label} htmlFor="service">
                    Service Interested In
                  </label>
                  <select
                    id="service"
                    name="service"
                    value={form.service}
                    onChange={handleChange}
                    onBlur={() => validateField('service', form.service)}
                    style={styles.select}
                    aria-label="Select a service"
                  >
                    {errors.service && (
  <span style={styles.error}>
    {errors.service}
  </span>
)}
                    <option value="">— Select a Service —</option>
                    {services.map((s) => (
                      <option key={s} value={s}>
                        {s}
                      </option>
                    ))}
                  </select>
                </div>

                {/* Message */}
                <div style={styles.fieldWrap}>
                  <label style={styles.label} htmlFor="message">
                    Message
                  </label>
                  <textarea
                    id="message"
                    name="message"
                    value={form.message}
                    onChange={handleChange}
                    onBlur={() => validateField('message', form.message)}
                    placeholder="Tell us how we can help..."
                    rows={4}
                    style={{
                      ...styles.input(!!errors.message),
                      resize: "vertical",
                    }}
                    aria-required="false"
                    aria-describedby="message-error"
                  />
                  {errors.message && (
                    <span id="message-error" style={styles.error}>
                      {errors.message}
                    </span>
                  )}
                </div>

                <button
                  type="submit"
                  disabled={loading}
                  className="btn-viha-primary"
                  style={{
                    ...styles.submitBtn,
                    opacity: loading ? 0.7 : 1,
                    cursor: loading ? "not-allowed" : "pointer",
                  }}
                >
                  {loading ? "Sending..." : "Send Message →"}
                </button>
              </form>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

const styles = {
  section: {
    backgroundColor: "#E8F5E2",
  },
  container: {
    maxWidth: 1140,
    margin: "0 auto",
    padding: "0 24px",
  },
  header: {
    textAlign: "center",
    marginBottom: 52,
  },
  title: {
    fontFamily: "'Playfair Display', serif",
    fontSize: "clamp(24px, 3.5vw, 36px)",
    color: "#1B3F6E",
    marginTop: 8,
  },
  twoCol: {
    display: "flex",
    gap: 40,
    flexWrap: "wrap",
    alignItems: "flex-start",
  },
  infoCol: {
    flex: "1 1 300px",
  },
  formCol: {
    flex: "2 1 400px",
  },
  infoCard: {
    backgroundColor: "#ffffff",
    borderRadius: 20,
    padding: "36px 32px",
    boxShadow: "0 4px 24px rgba(27,63,110,0.10)",
    height: "100%",
  },
  infoRow: {
    display: "flex",
    alignItems: "flex-start",
    gap: 16,
    marginBottom: 24,
    paddingBottom: 24,
    borderBottom: "1px solid #f0f4f8",
  },
  infoIcon: {
    width: 44,
    height: 44,
    borderRadius: "50%",
    backgroundColor: "#D6E8F7",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: 18,
    color: "#1B3F6E",
    flexShrink: 0,
  },
  infoLabel: {
    fontFamily: "'Lato', sans-serif",
    fontSize: 12,
    fontWeight: 700,
    color: "#5A9E4B",
    textTransform: "uppercase",
    letterSpacing: 1.5,
    marginBottom: 4,
  },
  infoValue: {
    fontFamily: "'Lato', sans-serif",
    fontSize: 14,
    color: "#2C2C2C",
    fontWeight: 500,
  },
  socialRow: {
    display: "flex",
    gap: 12,
    marginTop: 4,
  },
  socialIcon: (color) => ({
    width: 42,
    height: 42,
    borderRadius: "50%",
    backgroundColor: color,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#fff",
    fontSize: 18,
    textDecoration: "none",
    transition: "transform 0.25s ease, opacity 0.25s ease",
  }),
  form: {
    backgroundColor: "#ffffff",
    borderRadius: 20,
    padding: "36px 32px",
    boxShadow: "0 4px 24px rgba(27,63,110,0.10)",
  },
  fieldWrap: {
    marginBottom: 20,
  },
  label: {
    display: "block",
    fontFamily: "'Lato', sans-serif",
    fontSize: 13,
    fontWeight: 700,
    color: "#1B3F6E",
    marginBottom: 6,
    letterSpacing: 0.4,
  },
  input: (hasError) => ({
    width: "100%",
    padding: "12px 16px",
    borderRadius: 10,
    border: hasError ? "2px solid #e53e3e" : "2px solid #D6E8F7",
    fontFamily: "'Lato', sans-serif",
    fontSize: 15,
    color: "#2C2C2C",
    outline: "none",
    transition: "border-color 0.25s ease",
    backgroundColor: "#fafcff",
  }),
  select: {
    width: "100%",
    padding: "12px 16px",
    borderRadius: 10,
    border: "2px solid #D6E8F7",
    fontFamily: "'Lato', sans-serif",
    fontSize: 15,
    color: "#2C2C2C",
    backgroundColor: "#fafcff",
    outline: "none",
    cursor: "pointer",
  },
  error: {
    display: "block",
    color: "#e53e3e",
    fontSize: 16,
    marginTop: 5,
    fontFamily: "'Lato', sans-serif",
  },
  submitBtn: {
    width: "100%",
    padding: "14px",
    fontSize: 16,
    marginTop: 8,
    borderRadius: 10,
    textAlign: "center",
  },
  successBox: {
    backgroundColor: "#ffffff",
    borderRadius: 20,
    padding: "60px 32px",
    boxShadow: "0 4px 24px rgba(27,63,110,0.10)",
    textAlign: "center",
  },
  resetBtn: {
    marginTop: 24,
    background: "none",
    border: "2px solid #1B3F6E",
    color: "#1B3F6E",
    borderRadius: 50,
    padding: "10px 28px",
    fontFamily: "'Lato', sans-serif",
    fontWeight: 700,
    fontSize: 14,
    cursor: "pointer",
    transition: "all 0.25s ease",
  },
};

export default Contact;
